/**
 * fir-account's placeholder "Change Me" agency. Every submission that arrives
 * without a matched agency is parked under this holding record
 * (`SubmissionConstants.DUMMY_AGENCY_ID`), which is why it turns up in a
 * policyholder's interested-agencies list without anyone ever having expressed
 * interest.
 *
 * It is not a broker the policyholder could contact — the backend refuses to
 * quote or bind against it (`QuoteUtility.isChangeMeAgency`) — so it must never
 * be offered as an agent here either.
 */
export const CHANGE_ME_AGENCY_ID = '12345678-a1a1-a1a1-a1a1-123456789123';

const CHANGE_ME_NAME = 'change me';

interface AgencyLike {
  readonly id?: string;
  readonly agencyId?: string;
  readonly name?: string;
}

/**
 * Matches on the id first, since that is what the platform keys off. The name is
 * a fallback for rows that arrive without one: the interested list is assembled
 * from several sources and not all of them carry an agency id.
 */
export const isChangeMeAgency = (agency?: AgencyLike): boolean => {
  if (!agency) {
    return false;
  }
  if (
    agency.id === CHANGE_ME_AGENCY_ID ||
    agency.agencyId === CHANGE_ME_AGENCY_ID
  ) {
    return true;
  }
  return agency.name?.trim().toLowerCase() === CHANGE_ME_NAME;
};

export default isChangeMeAgency;
